import { Theme } from '@material-ui/core/styles';

export const getMuiTypography = (theme: Theme): Record<string, unknown> => ({
  MuiTypography: {
    root: {
      color: theme.palette.text.primary,
      padding: 0,
      textAlign: 'left',

      '& span': {
        color: theme.palette.text.primary,
      },

      '& a, a:hover, a:focus, a:active': {
        borderBottom: `1px dashed ${theme.palette.primary.main}`,
        color: 'inherit',
        textDecoration: 'none',
      },

      '& em': {
        fontStyle: 'normal',
        fontWeight: theme.typography.fontWeightMedium,
      },
    },

    button: {
      textTransform: 'none',
    },

    caption: {
      color: `${theme.palette.grey[800]}`,
      display: 'block',
      fontWeight: theme.typography.fontWeightRegular,

      '& a': {
        borderBottom: 'none',
        textDecoration: 'underline',

        '&:hover': {
          borderBottom: 'none',
          textDecoration: 'underline',
        },
      },
    },
    h1: {
      fontSize: theme.typography.pxToRem(28),

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(36),
      },
    },

    h2: {
      fontSize: theme.typography.pxToRem(21),

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },

    h3: {
      fontSize: theme.typography.pxToRem(16),

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
  },
});
